import { render, staticRenderFns } from "./demandHall.vue?vue&type=template&id=eb54f420&scoped=true&"
import script from "./demandHall.vue?vue&type=script&lang=js&"
export * from "./demandHall.vue?vue&type=script&lang=js&"
import style0 from "./demandHall.vue?vue&type=style&index=0&id=eb54f420&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb54f420",
  null
  
)

export default component.exports